import { render, staticRenderFns } from "./AdyenOnlineBankingPL.vue?vue&type=template&id=574c1ff5"
import script from "./AdyenOnlineBankingPL.vue?vue&type=script&lang=js"
export * from "./AdyenOnlineBankingPL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports